import { SurfaceConstants } from 'owa-calendar-surface-core';
import {
    CalendarSurfaceStore,
    getTimeStripWidth,
    CalendarSurfaceTransformProps,
    DatesColumnProvider,
    LinearItemsLayout,
} from 'owa-calendar-surface-dategrid';

/**
 * Function to create default day grid config.
 * @param store the surface store
 */
export function createDayGridConfig(store: CalendarSurfaceStore): CalendarSurfaceTransformProps {
    return {
        columnProvider: new DatesColumnProvider(store),
        itemsLayout: new LinearItemsLayout(store),
        renderDateHeaderAddOn: null,
        dragDropConfig: {
            canDrag: () => false,
            canDrop: () => false,
            onItemDropped: null,
            onDragStart: null,
            onDragEnd: null,
            getSurfaceItemForPreview: () => {
                return null;
            },
        },
        getItemConfig: null,
        supportExpandableAllDayWell: () => true,
        timeStripConfig: {
            headerWidth: getTimeStripWidth(
                store.timeZoneIds,
                SurfaceConstants.timeStripDefaultWidth
            ),
        },
    };
}
